import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { DropDownMeta } from 'src/app/shared/model/base-model';
import { WoOrderServiceDefaultItem, WoOrderServiceDefaultList, WoOrderServiceDefault } from 'src/app/models/response/wo-order-service-default.model';

@Injectable({
    providedIn: 'root'
})

export class WoOrderServiceDefaultService {

    private environmentUrl: string = '';

    constructor(private httpClient: HttpClient) {
        this.environmentUrl = environment.ApiCore + '/OrderServiceDefault/';
    }

    getItem(id: string): Observable<WoOrderServiceDefaultItem> {
        let url = this.environmentUrl + id;
        return this.httpClient.get<WoOrderServiceDefaultItem>(url);
    }

    getList(): Observable<WoOrderServiceDefaultList> {
        let url = this.environmentUrl;
        return this.httpClient.get<WoOrderServiceDefaultList>(url);
    }

    addItem(model: WoOrderServiceDefault) {
        let url = this.environmentUrl;
        return this.httpClient.post(url, model);
    }

    updItem(model: WoOrderServiceDefault) {
        let url = this.environmentUrl + model.id;
        return this.httpClient.put(url, model);
    }

    delItem(id: string) {
        let url = this.environmentUrl + id;
        return this.httpClient.delete(url);
    }

    getDropDownList(): Observable<DropDownMeta> {
        let url = this.environmentUrl + "DropDown";
        return this.httpClient.get<DropDownMeta>(url);
    }
}

